module.exports = __webpack_public_path__ + "fonts/dd7814bd-8abf-46c5-a4be-db0977de2cca.dda3c3e.woff2";